module.exports = "/build/web/svg/chevron-small-dark.47061dded9db8bee0aeb98b665f3e9ca.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/chevron-small-dark.svg
// module id = 103
// module chunks = 24